const elements = document.querySelectorAll("[data-observable]");
const callback = (entry, data) => {
  switch (data) {
    case "fade-up":
      {
        entry.classList.add("visible");
        break;
      }
    case "lazy-img":
      {
        entry.setAttribute("src", entry.getAttribute("data-src"));
        break;
      }
    case "fade-in-children":
      {
        Array.from(entry.children).forEach((child, i) => {
          setTimeout(() => {
            child.classList.add("!opacity-100");
          }, 1000 * i + 300);
        });
        break;
      }
    case "count-up":
      {
        const countUp = entry => {
          if (typeof animateCountUp !== "undefined") {
            animateCountUp(entry);
            return;
          }
          setTimeout(() => countUp(entry), 1000);
        };
        countUp(entry);
        break;
      }
    case "map":
      {
        if (!entry.hasAttribute("src")) {
          entry.src = !entry.getAttribute("x-src").startsWith("http") ? "https://google.com/" : entry.getAttribute("x-src");
        }
        break;
      }
    case "recaptcha":
      {
        loadReCaptcha();
        break;
      }
    case "facebook":
      {
        loadFacebookScript();
        break;
      }
    default:
      {
        console.error(`Unknown data-observable: ${data}`);
        break;
      }
  }
};
const observer = new IntersectionObserver(handleIntersection);
elements.forEach(obs => {
  observer.observe(obs);
});
function handleIntersection(entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      callback(entry.target, entry.target.getAttribute("data-observable"));
      //observer.unobserve(entry.target);
    }
  });
}

const onScrollEvents = [];
let lastKnownScrollPosition = 0;
let ticking = false;
document.addEventListener("scroll", event => {
  lastKnownScrollPosition = window.scrollY;
  if (!ticking) {
    window.requestAnimationFrame(() => {
      settings.onScroll.forEach(e => e(lastKnownScrollPosition));
      ticking = false;
    });
    ticking = true;
  }
});
const navbar = document.querySelector("nav");
const topbar = document.querySelector(".top-bar");
const positionTrigger = topbar?.clientHeight ?? 0;
settings.onScroll.push(lastKnownScrollPosition => {
  navbar.classList[lastKnownScrollPosition > positionTrigger ? "add" : "remove"]("scrolled");
});
const openModal = modal => {
  document.querySelector(`[modal=${modal}]`)?.classList.add("visible");
  loadReCaptcha();
};
document.querySelectorAll("[modal]").forEach(modal => {
  modal.addEventListener("click", e => {
    if (e.target.hasAttribute("modal")) {
      modal.classList.remove("visible");
    }
  });
});
function toggleMobileMenuJs(open) {
  document.body.classList[open ? "add" : "remove"]("menu-open");
}
document.querySelectorAll(".sub-menu").forEach(menu => {
  menu.setAttribute("height", menu.offsetHeight);
  menu.classList.add("max-h-0");
  if (menu.parentElement.classList.contains("open")) {
    menu.style.maxHeight = `${menu.getAttribute("height")}px`;
  }
});
document.querySelectorAll("[menu]").forEach(chevron => {
  chevron.addEventListener("click", () => {
    const open = document.querySelector(`.menu-${chevron.getAttribute("menu")}`).classList.contains("open");
    const submenu = document.querySelector(`.sub-menu-${chevron.getAttribute("menu")}`);
    if (open) {
      document.querySelector(`.menu-${chevron.getAttribute("menu")}`).classList.remove("open");
      submenu.style.maxHeight = `0px`;
    } else {
      document.querySelector(`.menu-${chevron.getAttribute("menu")}`).classList.add("open");
      submenu.style.maxHeight = `${submenu.getAttribute("height")}px`;
    }
  });
});
function handleSendEmailSubmit(token, formId) {
  const form = document.querySelector(`#${formId}`);
  const formButton = form.querySelector("button");
  if (formButton.classList.contains("loading")) {
    return;
  }
  formButton.classList.add("loading");
  const formData = new FormData(form);
  const formProps = Object.fromEntries(formData);
  let invalid = false;
  inputsRequired = formId == "send-email" ? ["email", "message"] : ["name", "phone", "email", "message", "agree"];
  inputsRequired.forEach(input => {
    if (!formProps[input]) {
      console.log("error");
      form.querySelector(`[name=${input}]`).setAttribute("error", "");
      invalid = true;
    }
    if (input == "email") {
      if (!/\S+@\S+\.\S+/.test(formProps[input])) {
        form.querySelector(`[name=${input}]`).setAttribute("error", "");
        invalid = true;
      }
    }
  });
  if (invalid) {
    formButton.classList.remove("loading");
    return;
  }
  fetch(`${settings.templateDir}/post/send-email.php`, {
    credentials: "same-origin",
    mode: "same-origin",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formProps)
  }).then(resp => {
    if (resp.status === 200) {
      return resp.json();
    } else {
      form.querySelector(".result-text").innerText = "Kunne ikke udføre anmodningen. Ring venligst direkte til os i stedet.";
      form.classList.add("text-red-600");
      return Promise.reject("server");
    }
  }).then(() => {
    formButton.classList.remove("loading");
    formButton.setAttribute("disabled", "");
    formButton.innerText = "Tak for din henvendelse!";
  }).catch(err => {
    if (err === "server") return;
    console.log(err);
  });
}
let reCaptchaLoaded = false;
function loadReCaptcha() {
  if (reCaptchaLoaded) return;
  reCaptchaLoaded = true;
  const recaptchaScript = document.createElement("script");
  recaptchaScript.src = "https://www.google.com/recaptcha/api.js?hl=en";
  recaptchaScript.defer = true;
  document.body.appendChild(recaptchaScript);
}
let facebookScriptLoaded = false;
function loadFacebookScript() {
  if (facebookScriptLoaded) return;
  facebookScriptLoaded = true;
  const facebookScript = document.createElement("script");
  facebookScript.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v13.0";
  facebookScript.defer = true;
  facebookScript.crossOrigin = "anonymous";
  document.body.appendChild(facebookScript);
}
const heroDelay = 5000;
const heroSlides = document.querySelectorAll(".hero-slide");
if (heroSlides.length > 1) {
  heroSlides.forEach((slide, i) => {
    setTimeout(() => {
      slide.classList.remove("opacity-0");
      setInterval(() => {
        heroSlides.forEach(slide => slide.classList.add("opacity-0"));
        slide.classList.remove("opacity-0");
      }, heroSlides.length * heroDelay);
    }, i * heroDelay);
  });
}
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
const allowCookies = allow => {
  setCookie('allowCookies', allow ? 'true' : 'false', 365);
  const cookiebox = document.querySelector('#cookiebox');
  cookiebox.style.bottom = "-30rem";
};